import { IReadRecordPlugin } from '@src/slide/application/no-edit/plugins/read-record/read-record-plugin.interface';
import { RightSideBarModule } from '@src/slide/application/service/edit-extension/edit-extension-export';

export const MODULE_NAME = 'read-record';

/**
 * 浏览记录侧边栏模块
 */
export class ReadRecordRightBarModule extends RightSideBarModule {
    private readRecordPlugin: IReadRecordPlugin;

    public constructor(readRecordPlugin: IReadRecordPlugin) {
        super();
        this.readRecordPlugin = readRecordPlugin;
    }

    public get name(): string {
        return MODULE_NAME;
    }

    public show(): void {
        this.readRecordPlugin.showModule(this.DOMNode, () => {
            this.showWrapper();
        }, () => {
            this.hideWrapper();
        }).then(() => { });
    }

    public wrapperDidHide(): void {
        this.readRecordPlugin.removeModule();
    }
}
